import { render } from "./expensesHistoryModal.vue?vue&type=template&id=7018a43e&scoped=true"
import script from "./expensesHistoryModal.vue?vue&type=script&lang=js"
export * from "./expensesHistoryModal.vue?vue&type=script&lang=js"

import "./expensesHistoryModal.vue?vue&type=style&index=0&id=7018a43e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7018a43e"]])

export default __exports__